import { type ErrorHandler } from '@angular/core';
import { type SentryErrorHandler } from '@sentry/angular';
import { posthog as Posthog } from 'posthog-js';

import { isNotUndefinedOrNull } from '@bizzdesign/bizzdesign-sdk';

export class CombinedErrorHandler implements ErrorHandler {
  public constructor(private readonly sentry: SentryErrorHandler) {}

  handleError(error: unknown): void {
    if (!isNotUndefinedOrNull(error)) {
      console.error({
        context: 'CombinedErrorHandler',
        msg: 'Null or undefined error captured',
      });
      return;
    }
    try {
      this.sentry.handleError(error);
    } catch (sentryError) {
      console.error({
        context: 'CombinedErrorHandler',
        msg: 'Sentry error handler failed',
        error: sentryError,
      });
    }
    try {
      Posthog.captureException(error);
    } catch (posthogError) {
      console.error({
        context: 'CombinedErrorHandler',
        msg: 'Posthog captureException failed',
        error: posthogError,
      });
    }
    console.error({
      context: 'CombinedErrorHandler',
      msg: 'Error handled',
      error: error,
    });
  }
}
